import React from 'react'
import { UserManagementRouteImport } from './Import'
const { RoutesMap, AddUser, UserList, UpdateUser } = UserManagementRouteImport

const UserManagementRoute = () => {
    return [
        {
            path: RoutesMap.ADD_USER.path,
            element: <AddUser />
        },
        {
            path: RoutesMap.UPDATE_USER.path,
            element: <UpdateUser />
        },
        {
            path: RoutesMap.USER_LIST.path,
            element: <UserList />
        },
    ]
}

export default UserManagementRoute;

